import React from 'react';
import { ConfigClientType } from '../types/ConfigClientType';
import { getTranslation } from '../../constants/languages';

type EmailHeaderProps = {
    iimclient: ConfigClientType;
};

const Translations = {
  lang_no: 'Skriv til oss',
  lang_se: 'Skriv till oss',
  lang_fi: 'Kirjoita meille',
  lang_dk: 'Skriv til os',
  lang_en: 'Write to us',
}

// No page exceptions found so far
const PageExceptions = {}

const EmailHeader = ({ iimclient }: EmailHeaderProps) => {
  const { lang } = iimclient;
  const translation = getTranslation(lang, Translations);
  return (
    <span className="heading" id="email-header">
      {translation}
    </span>
  );
};

export default EmailHeader;
